import { getTaxonomyCodeLabel } from '@/entities/license';
import type { License } from '@/entities/practice-member';
import { SettingsRow, SettingsRowActionButton } from '@/shared/ui/settings/settings-row';

type Props = {
    license: License;
    canDelete: boolean;
    isDisabled?: boolean;
    onEdit: () => void;
    onDelete: () => void;
};

// The title pairs the state with the license type's raw key (e.g. "California,
// LMFT") — the read schema keeps `type` and `state` as plain strings, so a retired
// dictionary key still renders instead of leaving the row blank.
export function ProfileLicenseRow({ license, canDelete, isDisabled, onEdit, onDelete }: Props) {
    const label = `${license.state}, ${license.type}`;

    return (
        <SettingsRow
            label={label}
            caption={
                <>
                    <div>License number: {license.number}</div>
                    {license.taxonomyCode && (
                        <div>Taxonomy: {getTaxonomyCodeLabel(license.taxonomyCode)}</div>
                    )}
                </>
            }
            trailing={
                <div className="flex items-center gap-2">
                    <SettingsRowActionButton
                        onClick={onEdit}
                        disabled={isDisabled}
                        aria-label={`Edit ${label} license`}
                    >
                        Edit
                    </SettingsRowActionButton>
                    {/* The at-least-one rule's visible half: Delete is absent at exactly one
                    license, never merely disabled, so the section can never return to empty. */}
                    {canDelete && (
                        <SettingsRowActionButton
                            onClick={onDelete}
                            disabled={isDisabled}
                            aria-label={`Delete ${label} license`}
                        >
                            Delete
                        </SettingsRowActionButton>
                    )}
                </div>
            }
        />
    );
}
